import { render, staticRenderFns } from "./SaldoCabang.vue?vue&type=template&id=a89f9d86"
import script from "./SaldoCabang.vue?vue&type=script&lang=js"
export * from "./SaldoCabang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports